import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

import team from './components/team';
import portfolio from './components/portfolio';
import slider from './components/slider';
import bannerMedia from './components/bannerMedia';

// Alpine — start first so pages render even if Swup init fails
Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.data('team', team);
Alpine.data('portfolio', portfolio);
Alpine.data('slider', slider);
Alpine.data('bannerMedia', bannerMedia);
Alpine.start();

// Swup 4 API — plugins array unchanged, but lifecycle moved to `hooks.on`
try {
  const swup = new Swup({
    plugins: [new SwupBodyClassPlugin()],
  });
  swup.hooks.on('content:replace', () => {
    window.scroll(0, 0);
  });
} catch (err) {
  console.warn('[flyvc] Swup init failed; falling back to full page loads.', err);
}

document.addEventListener('DOMContentLoaded', () => {
  window.scroll(0, 0);
});
